import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ADD_MODELS } from './constants';
import {
  AddModelsSuccess,
  AddModelsError,
  AddModelsDataActionTypes,
  AddModelsState,
} from './types';

const initialState: AddModelsState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (draft = initialState, action: AddModelsDataActionTypes): AddModelsState => {
    switch (action.type) {
      case ADD_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ADD_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AddModelsSuccess).payload;
        break;
      }
      case ADD_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AddModelsError).error;
        break;
      }
      case ADD_MODELS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
